"use client";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Link from "next/link";
import Image from "next/image";
import Input from "@/app/components/ui/forms/Input";
import Button from "@/app/components/ui/buttons/Button";
import { forgotPasswordSchema, ForgotPasswordFormValues } from "@/app/schemas/auth.schema";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormValues>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data: ForgotPasswordFormValues) => {
    setIsLoading(true);
    try {
      console.log(data);
      // API çağrısı burada yapılacak
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md rounded-md bg-white p-8">
      <div className="mb-10 text-center">
        <Image src="/images/logo.png" alt="Logo" width={150} height={50} className="mx-auto mb-8" />
        <h2 className="mb-2 text-3xl font-bold text-gray-900">Şifreni mi Unuttun?</h2>
        <p className="text-gray-600">E-mail adresini yazarak devam edin</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="E-posta"
          name="email"
          type="email"
          placeholder="E-Mail Adresinizi Giriniz"
          register={register}
          error={errors.email}
        />

        <Button type="submit" fullWidth isLoading={isLoading}>
          Şifre Sıfırlama Bağlantısı Gönder
        </Button>

        <div className="text-center">
          <Link
            href="/login"
            className="text-sm font-medium text-xBlue transition-colors hover:text-xBlue/90"
          >
            Giriş sayfasına dön
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
